module.exports = __webpack_public_path__ + "img/request-fail.021a5a4a.png";